import React from "react";
import PatientSatuSehat from "./Patient";
import { Col, Row } from "reactstrap";
import EncounterSatuSehat from "./Encounter";
import AppointmentHistory from "./Appointment";
import ConditionSatuSehat from "./Condition";
import ObservationSatuSehat from "./Observation";
import ProcedureSatuSehat from "./Procedure";

export default function HompageSatuSehat({
    getData,
    getIdPatientSSP,
    getDataAppointmentPatient,
    getProvince,
    getCity,
    getRegency,
    getDistrict,
    getEncounter,
    getCondition,
    getObservation,
    getProcedure
}) {
    return (
        <>
            <div style={{ display: 'block', height: '100%', overflowY: 'auto', overflowX: 'auto', padding: "10px" }}>
                <div className="container mt-2">
                    <div className="columns">
                        <div className="column is-4">
                            {/* Patient Start */}
                            <PatientSatuSehat
                                getData={getData}
                                getIdPatientSSP={getIdPatientSSP}
                                getDataAppointmentPatient={getDataAppointmentPatient}
                                getProvince={getProvince}
                                getCity={getCity}
                                getRegency={getRegency}
                                getDistrict={getDistrict}
                            />
                            {/* Patient Finish */}
                            <Row className="g-4 mt-2">
                                <Col md={12}>
                                    {/* Encounter Start */}
                                    <EncounterSatuSehat
                                        getEncounter={getEncounter}
                                    />
                                    {/* Encounter Finish */}
                                </Col>
                            </Row>
                        </div>
                        <div className="column is-8">
                            <Row className="g-1">
                                <Col md={12}>
                                    {/* Appointment Start */}
                                    <AppointmentHistory
                                        getDataAppointmentPatient={getDataAppointmentPatient}
                                    />
                                    {/* Appointment Finish */}
                                </Col>
                                <Col md={12}>
                                    {/* Condition Start */}
                                    <ConditionSatuSehat
                                        getCondition={getCondition}
                                    />
                                    {/* Condition Finish */}
                                </Col>
                                <Col md={12}>
                                    {/* Observation Start */}
                                    <ObservationSatuSehat
                                        getObservation={getObservation}
                                    />
                                    {/* Observation Finsih */}
                                </Col>
                                <Col md={12}>
                                    {/* Procedure Start */}
                                    <ProcedureSatuSehat
                                        getProcedure={getProcedure}
                                    />
                                    {/* Procedure Finsih */}
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


